import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { DashboardSkillsFilter, filtersInitialState } from '../../models/DashboardSkillsFilter';

export interface filterState {
  value: DashboardSkillsFilter;
}

const initialState: filterState = { value: filtersInitialState };

export const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setFilter: (state: filterState, action: PayloadAction<DashboardSkillsFilter>) => {
      state.value = action.payload;
    },
  },
});

export const selectedFilter = (state: RootState) => state.filter.value;

export const { setFilter } = filterSlice.actions;

export default filterSlice.reducer;
